@if (showColorDot) {
  <div
    class="flex cursor-pointer flex-col rounded px-3 py-1 transition-colors hover:bg-greyscale-50/50 sm:flex-row sm:items-center sm:justify-between"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
    <!-- Élément avec couleur et nom - mobile: pleine largeur -->
    <div
      class="flex min-w-0 items-center gap-2"
      [pTooltip]="
        item.isEcoFriendly
          ? item.title
            ? item.title +
              ' (' +
              item.label +
              ') ' +
              ('fields.isEcoFriendly' | transloco)
            : item.label + ('fields.isEcoFriendly' | transloco)
          : item.title
            ? item.title + ' (' + item.label + ')'
            : item.label
      "
      tooltipPosition="top"
    >
      <div
        class="h-2 w-2 flex-shrink-0 rounded-full"
        [style.background-color]="item.color"
      ></div>
      <div class="min-w-0">
        @if (item.title) {
          <span class="block truncate text-paragraph-s-reg text-greyscale-700"
            >{{ item.title }}
            <span class="ml-1 text-paragraph-xs-reg text-greyscale-500"
              >({{ item.label }})</span
            ></span
          >
        } @else {
          <span
            class="block truncate text-paragraph-s-reg text-greyscale-700"
            >{{ item.label }}</span
          >
        }
      </div>
      @if (item.isEcoFriendly) {
        <lucide-icon
          name="leaf"
          class="rounded-full bg-primary-100 p-0.5 text-primary-600"
          [size]="16"
        />
      }
    </div>

    <!-- Valeurs - mobile: en dessous à droite, desktop: alignées avec les titres -->
    <div
      class="mt-1 flex items-center justify-end gap-2 pl-4 text-paragraph-s-reg tabular-nums sm:mt-0 sm:pl-0"
    >
      @if (isSimulated) {
        <span
          class="w-12 shrink-0 text-right text-paragraph-xs-reg text-greyscale-400 line-through"
          >{{ showsReduction ? previousValue : "" }}</span
        >
      }
      <div class="w-20 text-right">
        <span class="font-medium text-greyscale-800">{{
          formatCo2e.formatValue(item.impact)
        }}</span>
        <span class="text-paragraph-xs-reg text-greyscale-500">
          {{ formatCo2e.getUnit(item.impact, { perPerson: perPerson }) }}</span
        >
      </div>
      @if (showPercentage) {
        <div class="w-12 text-right">
          <span class="text-paragraph-xs-reg font-medium text-primary-600"
            >{{ item.percentage }}%</span
          >
        </div>
      }
    </div>
  </div>
} @else {
  <div
    class="flex flex-col rounded px-3 py-1 transition-colors sm:flex-row sm:items-center sm:justify-between"
  >
    <!-- Élément informatif sans pastille - mobile: pleine largeur -->
    <div class="flex min-w-0 flex-1 items-center gap-2">
      <div class="min-w-0 flex-1">
        @if (item.title) {
          <span
            class="block truncate text-paragraph-s-reg text-greyscale-700"
            [pTooltip]="
              item.isEcoFriendly
                ? item.title +
                  ' (' +
                  item.label +
                  ') · Logement éco-responsable'
                : item.title + ' (' + item.label + ')'
            "
            tooltipPosition="top"
            >{{ item.title }}
            <span class="ml-1 text-paragraph-xs-reg text-greyscale-500"
              >({{ item.label }})</span
            ></span
          >
        } @else {
          <span
            class="block truncate text-paragraph-s-reg text-greyscale-700"
            [pTooltip]="
              item.isEcoFriendly
                ? item.label + ' · Logement éco-responsable'
                : item.label
            "
            tooltipPosition="top"
            >{{ item.label }}</span
          >
        }
      </div>
    </div>

    <!-- Valeurs - mobile: en dessous à droite, desktop: alignées avec les titres -->
    <div
      class="mt-1 flex items-center justify-end gap-2 pl-4 text-paragraph-s-reg tabular-nums sm:mt-0 sm:pl-0"
    >
      @if (isSimulated) {
        <span
          class="w-12 shrink-0 text-right text-paragraph-xs-reg text-greyscale-400 line-through"
          >{{ showsReduction ? previousValue : "" }}</span
        >
      }
      <div class="w-20 text-right">
        <span class="font-medium text-greyscale-800">{{
          formatCo2e.formatValue(item.impact)
        }}</span>
        <span class="text-paragraph-xs-reg text-greyscale-500">
          {{ formatCo2e.getUnit(item.impact, { perPerson: perPerson }) }}</span
        >
      </div>
      @if (showPercentage) {
        <div class="w-12 text-right">
          <span class="text-paragraph-xs-reg font-medium text-primary-600"
            >{{ item.percentage }}%</span
          >
        </div>
      }
    </div>
  </div>
}
